import { Space, Button, Col, Row, Statistic, Drawer, Tabs, Flex, Tag, Typography, Divider } from 'antd';
import { useNavigate } from 'react-router';
import { formatDate } from 'utils/date';
import { formatCurrency } from 'utils/number';
import Debt from '../Debt';
import CustomerInfoEdit from 'components/customer/CustomerInfoEdit';
import CustomerLoginEdit from 'components/customer/CustomerLoginEdit';
import _ from 'lodash';

const { Text } = Typography;

const getOrderStatusTag = (status) => {
  if (status === 'canceled') return <Tag color="error">Đã huỷ</Tag>;
  if (status === 'finalized') return <Tag color="success">Đã hoàn tất</Tag>;
  return <Tag color="processing">Đang xử lý</Tag>;
};

const MobileInfoModal = ({
  isModalOpen,
  customer,
  orders,
  showCustomerEdit,
  setShowCustomerEdit,
  showCustomerLoginEdit,
  setShowCustomerLoginEdit,
  isAccountLoginMode,
  handleCancel,
  onCustomerSave,
}) => {
  const navigate = useNavigate();

  const infoTab = (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      {/* Basic info */}
      <Space direction="vertical" size={6} style={{ width: '100%' }}>
        <Flex justify="space-between">
          <Text type="secondary">Họ và tên</Text>
          <Text strong>{customer.full_name}</Text>
        </Flex>
        <Divider style={{ margin: 0 }} />
        <Flex justify="space-between">
          <Text type="secondary">Số điện thoại</Text>
          <Text>{customer.phone}</Text>
        </Flex>
        <Divider style={{ margin: 0 }} />
        <Flex justify="space-between" align="flex-start" gap={8}>
          <Text type="secondary" style={{ flexShrink: 0 }}>Địa chỉ</Text>
          <Text style={{ textAlign: 'right' }}>{customer.address || '—'}</Text>
        </Flex>
      </Space>

      {/* Stats */}
      <Row gutter={[8, 8]}>
        <Col span={12}><Statistic title="Đơn hàng" value={orders.length} /></Col>
        <Col span={12}>
          <Statistic
            title="Tổng tiền"
            value={_.sumBy(orders, (x) => x.total_amount ?? 0)}
            precision={0}
          />
        </Col>
        <Col span={12}>
          <Statistic title="Xu" value={customer.loyalty_point?.current ?? 0} precision={0} />
        </Col>
        {customer.debt?.current_debt !== 0 && (
          <Col span={12}>
            <Statistic title="Nợ" value={customer.debt?.current_debt ?? 0} precision={0} />
          </Col>
        )}
      </Row>

      {/* Action buttons */}
      <Space direction="vertical" size={8} style={{ width: '100%' }}>
        <Button block type="primary" onClick={() => setShowCustomerEdit(true)}>
          Cập nhật thông tin
        </Button>
        {isAccountLoginMode && (
          <Button block onClick={() => setShowCustomerLoginEdit(true)}>
            Quản lý đăng nhập
          </Button>
        )}
      </Space>
    </Space>
  );

  const orderTab = (
    <Space direction="vertical" size={8} style={{ width: '100%' }}>
      {(orders || []).map((record) => (
        <div
          key={record.id}
          style={{
            borderRadius: 8,
            border: '1px solid #f0f0f0',
            padding: '8px 12px',
            background: '#fafafa',
            cursor: 'pointer',
          }}
          onClick={() => navigate(`/order/${record.id}`)}
        >
          <Flex justify="space-between" align="center">
            <Space direction="vertical" size={0}>
              <Text strong style={{ fontSize: 13 }}>#{record.id}</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>{formatDate(record.create_on)}</Text>
            </Space>
            {getOrderStatusTag(record.status)}
          </Flex>
          <Flex justify="space-between" style={{ marginTop: 6 }}>
            <Text style={{ fontSize: 13 }}>{record.total_item} sản phẩm</Text>
            <Text strong style={{ fontSize: 13 }}>{formatCurrency(record.total_amount)}</Text>
          </Flex>
        </div>
      ))}
      {(!orders || orders.length === 0) && (
        <Text type="secondary">Chưa có đơn hàng nào</Text>
      )}
    </Space>
  );

  const items = [
    {
      key: 'info',
      label: 'Thông tin',
      children: infoTab,
    },
    {
      key: 'order',
      label: 'Đơn hàng',
      children: orderTab,
    },
    {
      key: 'debt',
      label: 'Công nợ',
      children: <Debt customer={customer} onChange={onCustomerSave} />,
    },
  ];

  return (
    <>
      <Drawer
        title="Thông tin khách hàng"
        placement="bottom"
        height="90%"
        open={isModalOpen}
        onClose={handleCancel}
        destroyOnClose
      >
        <Tabs items={items} />
      </Drawer>

      <CustomerInfoEdit
        id={customer.id}
        open={showCustomerEdit}
        onSave={onCustomerSave}
        onClose={() => setShowCustomerEdit(false)}
      />
      <CustomerLoginEdit
        id={customer.id}
        open={showCustomerLoginEdit}
        onSave={onCustomerSave}
        onClose={() => setShowCustomerLoginEdit(false)}
      />
    </>
  );
};

export default MobileInfoModal;
